import { render, staticRenderFns } from "./AddUser.vue?vue&type=template&id=272acbfb&scoped=true&"
import script from "./AddUser.vue?vue&type=script&lang=js&"
export * from "./AddUser.vue?vue&type=script&lang=js&"
import style0 from "./AddUser.vue?vue&type=style&index=0&id=272acbfb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272acbfb",
  null
  
)

export default component.exports